import { Component, OnInit } from '@angular/core'
import { RegistrationService } from '@service/registration.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ToastService } from '@service/toast/toast.service'
import { ActivatedRoute } from '@angular/router'
import { StateService } from '@service/state.service'
import { MatDialog } from '@angular/material/dialog'
import { IntroductionDialogComponent } from '@modal/introduction-dialog/introduction-dialog.component'
import { Angulartics2Facebook } from 'angulartics2'
import { forkJoin, take } from 'rxjs'

@Component({
  selector: 'app-sso-registration',
  templateUrl: './sso-registration.component.html',
  styleUrls: ['./sso-registration.component.scss'],
})
export class SsoRegistrationComponent implements OnInit {

  public loading: boolean = false

  public form: FormGroup = null

  private params

  constructor(
    private registrationService: RegistrationService,
    private toastService: ToastService,
    private ActivatedRoute: ActivatedRoute,
    private StateService: StateService,
    private MatDialog: MatDialog,
    private Angulartics2Facebook: Angulartics2Facebook,
    private formBuilder: FormBuilder,
  ) {
    forkJoin({
      params: this.ActivatedRoute.params.pipe(take(1)),
      query: this.ActivatedRoute.queryParams.pipe(take(1)),
    }).subscribe(data => {

      const params = data.params;
      const query = data.query;

      this.params = params;

      // if id or code is not set -> die
      if (typeof params['user_id'] == "undefined" || params['id'] === null ||
        typeof params['confirmation_code'] == "undefined" || params['confirmation_code'] === null) {
        this.StateService.goto('/news')
        return
      }

      let user_id = params['user_id']
      let confirmation_code = params['confirmation_code']

      this.loading = true

      // check if id / confirmation_code exist -> else go home
      this.registrationService.SSORegisterExists(user_id, confirmation_code)
        .then(() => {

          this.form = this.formBuilder.group({
            firstname: [query.firstname ?? '', [Validators.required, Validators.minLength(2)]],
            lastname: [query.lastname ?? '', [Validators.required, Validators.minLength(2)]],
            privacy: [false, [Validators.requiredTrue]],
            newsletter: [false],
          });

          if (params['r'] == 'success-login') {

            this.registrationService.loginSSO(
              params['user_id'],
              params['confirmation_code']
            )
              .then(() => {
                this.StateService.goto('/news')
              })
              .catch(e => {
                console.error(e)
              })
              .finally(() => {
                this.loading = false
              })
          }

        })
        .catch(() => {
          this.StateService.goto('/news')
          this.toastService.showWarning("Dieser Link ist nicht mehr gültig.")
        })
        .finally(() => {
          this.loading = false
        })

    })
  }

  ngOnInit() { }

  public onSubmit() {
    if (this.form.invalid)
      return

    this.loading = true

    const values = this.form.value;

    this.registrationService.verifySSOAlternative({
      firstname: values.firstname,
      lastname: values.lastname,
      privacy: values.privacy,
      newsletter: values.newsletter,
      user_id: this.params['user_id'],
      confirmation_code: this.params['confirmation_code'],
    }).then(() => {
      this.StateService.goto('/profile/about')

      // facebook track
      this.Angulartics2Facebook.eventTrack('CompleteRegistration', {})

      const config = {}
      this.MatDialog.open(IntroductionDialogComponent, {
        data: config,
        disableClose: false,
        width: '100vw',
        maxWidth: '100vw',
        height: '100vh',
        panelClass: IntroductionDialogComponent.cssClass
      })
    }).catch(() => {
      this.toastService.showError("Die AGB muss akzeptiert werden");
    }).finally(() => {
      this.loading = false
    })
  }

  public onCancel() {
    this.loading = true

    this.registrationService
      .cancelSSO(this.params['user_id'], this.params['confirmation_code'])
      .then(() => {
        this.loading = false
        this.toastService.showSuccess("Die Registrierung wurde abgebrochen");
        this.StateService.goto('/news')
      })
      .catch(() => {
        this.loading = false
      })
  }
}
